import api from "../Api";

// helper: build auth headers from stored token
const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const MEDIA_BASE_URL = "https://didamax.net/"; // لو الصور بتبقى relative path

const makeAbsoluteUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http://") || u.startsWith("https://")) return u;
  return `${MEDIA_BASE_URL}${u.replace(/^\/+/, "")}`;
};

const urlToFileStrict = async (url, filename) => {
  const absolute = makeAbsoluteUrl(url);

  const res = await fetch(absolute, { cache: "no-store" });
  if (!res.ok) {
    throw new Error(`Failed to fetch image: ${res.status}`);
  }

  const blob = await res.blob();

  // ✅ أهم جزء: لازم يكون image فعلاً
  if (!blob.type || !blob.type.startsWith("image/")) {
    throw new Error(
      `Fetched file is not an image (type=${blob.type || "unknown"}). URL=${absolute}`
    );
  }

  return new File([blob], filename, { type: blob.type });
};


// جلب البانرات الإعلانية
export const getAdvertisingBanners = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(`/admin/get-advertising-banners`, {
      headers,
      params: mergedParams,
    });

    // حسب الصورة: الريسبونس Array مباشرة
    return response.data;
  } catch (error) {
    console.error("Error fetching advertising banners:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];

      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};

export const createAdvertisingBanner = async (data) => {
  if (!data) throw new Error("data is required");

  const formData = new FormData();

  // لا تبعت null في FormData
  if (data.title_ar) formData.append("title_ar", data.title_ar);
  if (data.title_en) formData.append("title_en", data.title_en);
  if (data.description_ar) formData.append("description_ar", data.description_ar);
  if (data.description_en) formData.append("description_en", data.description_en);

  if (data.is_active !== undefined && data.is_active !== null)
    formData.append("is_active", data.is_active ? 1 : 0);

  if (data.display_order !== undefined && data.display_order !== null)
    formData.append("display_order", String(data.display_order));

  if (data.start_date) formData.append("start_date", data.start_date);
  if (data.end_date) formData.append("end_date", data.end_date);

  if (data.image) formData.append("image", data.image);
  if (data.image_web) formData.append("image_web", data.image_web);

  // ✅ مهم: السيرفر عندك شغال بصيغة category_ids[0], category_ids[1] (زي Postman)
  if (Array.isArray(data.category_ids)) {
    data.category_ids.forEach((id, idx) => {
      formData.append(`category_ids[${idx}]`, String(Number(id)));
    });
  }

  try {
    const response = await api.post("/admin/create-advertising-banner", formData, {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
      params: { api_password: "EcommercApp@2026_$" },
    });

    // ✅ توحيد شكل الريسبونس
    return {
      success: true,
      ...response.data,
    };
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) throw new Error(msgs.join(" | "));
    }
    throw error;
  }
};
// تعديل بانر إعلاني موجود
export const updateAdvertisingBanner = async (bannerId, data, params = {}) => {
  if (!bannerId) throw new Error("bannerId is required");
  if (!data || typeof data !== "object") throw new Error("data is required");

  const formData = new FormData();

  // نصوص
  if (data.title_ar != null) formData.append("title_ar", String(data.title_ar));
  if (data.title_en != null) formData.append("title_en", String(data.title_en));
  if (data.description_ar != null) formData.append("description_ar", String(data.description_ar));
  if (data.description_en != null) formData.append("description_en", String(data.description_en));
  if (data.is_active != null) formData.append("is_active", data.is_active ? "1" : "0");
  if (data.display_order != null) formData.append("display_order", String(data.display_order));
  if (data.start_date != null) formData.append("start_date", String(data.start_date));
  if (data.end_date != null) formData.append("end_date", String(data.end_date));

  // ✅ الصور: ابعتها فقط لو File جديد
  if (data.image instanceof File) formData.append("image", data.image);
  if (data.image_web instanceof File) formData.append("image_web", data.image_web);

  // التصنيفات
  if (Array.isArray(data.category_ids)) {
    data.category_ids.forEach((id, idx) => {
      formData.append(`category_ids[${idx}]`, String(Number(id)));
    });
  }

  const mergedParams = { api_password: "EcommercApp@2026_$", ...params };

  const response = await api.post(
    `/admin/update-advertising-banner/${bannerId}`,
    formData,
    {
      headers: { ...getAuthHeaders(), "Content-Type": "multipart/form-data" },
      params: mergedParams,
    }
  );

  return { success: true, ...response.data };
};

// ✅ حذف بانر إعلاني
export const deleteAdvertisingBanner = async (bannerId, params = {}) => {
  if (!bannerId) throw new Error("bannerId is required to delete advertising banner.");

  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(
      `/admin/delete-advertising-banner/${bannerId}`,
      {
        headers,
        params: mergedParams,
      }
    );

    // ✅ توحيد الريسبونس (لأن API غالبًا بيرجع message_ar/message_en بدون success)
    return {
      success: true,
      ...response.data,
    };
  } catch (error) {
    console.error("Error deleting advertising banner:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];

      if (serverData.message) msgs.push(serverData.message);
      if (serverData.error) msgs.push(serverData.error);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// ✅ إضافة تصنيفات لبانر

export const addCategoriesToBanner = async (bannerId, categoryIds = [], params = {}) => {
  if (!bannerId) throw new Error("bannerId is required.");

  if (!Array.isArray(categoryIds) || categoryIds.length === 0) {
    throw new Error("categoryIds must be a non-empty array.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  const payload = {
    category_ids: categoryIds.map((id) => Number(id)),
  };

  try {
    const response = await api.post(
      `/admin/add-categories-to-banner/${bannerId}`,
      payload,
      { headers, params: mergedParams }
    );

    return response.data;
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.error) msgs.push(serverData.error);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.entries(serverData.errors).forEach(([k, v]) => {
          if (Array.isArray(v)) msgs.push(`${k}: ${v.join(", ")}`);
          else msgs.push(`${k}: ${v}`);
        });
      }

      if (msgs.length) throw new Error(msgs.join(" | "));
    }
    throw error;
  }
};
// ✅ إزالة تصنيفات من بانر (JSON)
export const removeCategoriesFromBanner = async (bannerId, categoryIds = [], params = {}) => {
  if (!bannerId) throw new Error("bannerId is required.");

  if (!Array.isArray(categoryIds) || categoryIds.length === 0) {
    throw new Error("categoryIds must be a non-empty array.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  const payload = {
    category_ids: categoryIds.map((id) => Number(id)),
  };

  try {
    const response = await api.post(
      `/admin/remove-categories-from-banner/${bannerId}`,
      payload,
      { headers, params: mergedParams }
    );

    return response.data;
  } catch (error) {
    console.error("Error removing categories from banner:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.error) msgs.push(serverData.error);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.entries(serverData.errors).forEach(([k, v]) => {
          if (Array.isArray(v)) msgs.push(`${k}: ${v.join(", ")}`);
          else msgs.push(`${k}: ${v}`);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};